import { css, html, TemplateResult } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { BaseComponent } from '../base-component/base-component';
import { parseBrowser, parseOS } from './system-check-utils';

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-system-check': SystemCheck;
  }
}

@customElement('mhecomm-system-check')
export class SystemCheck extends BaseComponent {
  static styles = [
    css`
      .system-check-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.95rem;
      }
      .system-check-table td {
        padding: 0.5rem 0.75rem;
        border: 1px solid #dee2e6;
        vertical-align: top;
        word-break: break-word;
      }
      .system-check-table td:first-child {
        width: 180px;
        font-weight: 600;
        white-space: nowrap;
        background-color: #f8f9fa;
      }
    `,
  ];

  @state() private ipAddress = 'Loading...';
  @state() private popupsAllowed: boolean | null = null;

  connectedCallback(): void {
    super.connectedCallback();
    this._fetchIp();
  }

  private async _fetchIp(): Promise<void> {
    try {
      const res = await fetch('/api/client-ip');
      if (!res.ok) throw new Error(`Response status: ${res.status}`);
      const ip = res.headers.get('x-client-ip');
      if (!ip) throw new Error('x-client-ip header missing');
      this.ipAddress = ip;
    } catch {
      this.ipAddress = 'Unavailable';
    }
  }

  private _testPopups(): void {
    const win = window.open('', '_blank', 'width=1,height=1,left=-9999');
    if (win) {
      win.close();
      this.popupsAllowed = true;
    } else {
      this.popupsAllowed = false;
    }
  }

  private get _popupCell(): TemplateResult {
    if (this.popupsAllowed === null) {
      return html`<button class="btn btn-sm btn-secondary" @click=${this._testPopups}>Test Pop-Ups</button>`;
    }
    return html`${this.popupsAllowed ? 'Allowed' : 'Blocked'}`;
  }

  renderComp(): TemplateResult {
    const ua = navigator.userAgent;
    return html`
      <table class="system-check-table">
        <tbody>
          <tr>
            <td>Agent</td>
            <td>${ua}</td>
          </tr>
          <tr>
            <td>IP Address</td>
            <td>${this.ipAddress}</td>
          </tr>
          <tr>
            <td>Browser</td>
            <td>${parseBrowser(ua)}</td>
          </tr>
          <tr>
            <td>Cookies</td>
            <td>${navigator.cookieEnabled ? 'Enabled' : 'Disabled'}</td>
          </tr>
          <tr>
            <td>Operating System</td>
            <td>${parseOS(ua)}</td>
          </tr>
          <tr>
            <td>JavaScript</td>
            <td>Enabled</td>
          </tr>
          <tr>
            <td>Pop-Ups</td>
            <td>${this._popupCell}</td>
          </tr>
        </tbody>
      </table>
    `;
  }
}
